enum CellSpacingEnum {
  "NO_SPACE" = 1,
  "SPACED" = 2,
}

export default CellSpacingEnum;
